import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import axios from 'axios';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartPayment from './components/ChartPayment';
import ChartInterestRate from './components/ChartInterestRate';
import Modal from 'react-modal';
import MortgageCalculationTable from './components/MortgageCalculationTable';
import LoadingSpinner from './components/LoadingSpinner';
import Toggle from './components/Toggle';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement);

/*Custom styles for modal*/
const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: '600px',
      borderRadius: '10px',
      padding: '50px 60px 50px 60px'
    },
  };

  Modal.setAppElement('#root');

class Calculator extends React.Component {
    
    constructor(props) {
        super(props);

        this.chartReference = {};

        this.state = {
            isLoading: false,
            hasResult: false,
            isInternal: window.mortgageCalculatorConfig.isInternal,
            purchasePrice: window.mortgageCalculatorConfig.defaultPuchasePrice,
            deposit: window.mortgageCalculatorConfig.defaultDeposit,
            term: window.mortgageCalculatorConfig.termDefault,
            interestFlex: window.mortgageCalculatorConfig.defaultFlexRate,
            interestRateAfter5Years: window.mortgageCalculatorConfig.defaultExtendedRate,
            interestRateFirst5Years: window.mortgageCalculatorConfig.defaultInterestRate,
            modalApplyIsOpen: false,
            applyMortgageName: '',
            applyMortgagePhone: '',
            applyMortgageEmail: '',
            applyMortgageAddress: '',
            applyMortgageCity: '',
            applyMortgageLoanType: 'Flex Amortised',
            applyMortgageAlreadyCustomer: 'No',
            applyMortgageMsg: '',
            applyMortgageSendSuccess: false,
            applyMortgageSendError: false,
            applyMortgageValidateError: false,
            modalCompetitorIsOpen: false,
            competitorDisplay: false,
            competitorHasCalculation: false,
            competitorCommitmentPeriod: window.mortgageCalculatorConfig.competitorCommitmentPeriodDefault,
            competitorInitialRate: window.mortgageCalculatorConfig.competitorInitialRateDefault,
            competitorExtendedRate: window.mortgageCalculatorConfig.competitorExtendedRateDefault,
            interestComment: window.mortgageCalculatorConfig.interestComment,
            applyMortgageSuccessMsg: window.mortgageCalculatorConfig.applyMortgageSuccessMsg,
        }    
        this.chartdata = {
            labels: ['Deposit', 'Mortgage'],
                
            datasets: [
                {
                data: [this.state.deposit, (this.state.purchasePrice - this.state.deposit)],
                backgroundColor: [
                    '#0B5240',
                    '#22866C'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)'
                ],
                borderWidth: 0,
                },
            ]
                
        };
        this.chartOptions = {
            cutout: 75,
            responsive: true,
            plugins: {
                legend: {
                  position: 'bottom',
                  labels: {
                    padding: 20
                  },
                  onClick: (e) => e.stopPropagation()
                },
                tooltip: {
                    callbacks: {
                      label: function(context) {
                        var sum = (context.dataset.data[0] + context.dataset.data[1]);


                        return context.label + ': £' + context.formattedValue + ' (' + Math.round(context.dataset.data[context.dataIndex] / sum * 100) + '%)';
                      }
                  }
                  }
              },
              
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleDepositChange = this.handleDepositChange.bind(this);
        this.handlePurchasePriceChange = this.handlePurchasePriceChange.bind(this);
        this.handleTermChange = this.handleTermChange.bind(this);
        this.handleCommitmentPeriodChange = this.handleCommitmentPeriodChange.bind(this);
        this.handleApplyMortgageAlreadyCustomer = this.handleApplyMortgageAlreadyCustomer.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.applyMortgage = this.applyMortgage.bind(this);
        this.addCompetitorData = this.addCompetitorData.bind(this);
        this.resetCompetitorData = this.resetCompetitorData.bind(this);
        this.openModalCompetitor = this.openModalCompetitor.bind(this);
        this.closeModalCompetitor = this.closeModalCompetitor.bind(this);
        this.toggleCompetitorData = this.toggleCompetitorData.bind(this);
    }

    openModal(){
        this.setState({modalApplyIsOpen: true, applyMortgageSendError:false, applyMortgageSendSuccess:false});
    }

    closeModal() {
        this.setState({modalApplyIsOpen: false, applyMortgageSendError:false, applyMortgageSendSuccess:false});
    }

    openModalCompetitor(){
        this.setState({modalCompetitorIsOpen: true});
    }

    closeModalCompetitor(){
        this.setState({modalCompetitorIsOpen: false});
    }

    handleTermChange(event){
        this.setState({term: event.target.value});
        this.getCalculation(event.target.value);
        event.preventDefault();
    }
    handleCommitmentPeriodChange(event){
        this.setState({competitorCommitmentPeriod: event.target.value});
        event.preventDefault();
    }

    handleSubmit(event) {
        this.getCalculation(this.state.term);
        event.preventDefault();
    }

    handleApplyMortgageAlreadyCustomer(event){
        this.setState({applyMortgageAlreadyCustomer: event.target.value});
    }

    getCompetitorCalculation(){
        var self = this;
        this.setState({isLoading: true});
        axios.get('https://func-py-mortgage-calculator.azurewebsites.net/api/competitor-calculation?purchasePrice=' + this.state.purchasePrice + '&applicantContribution=' + this.state.deposit + '&termRequested=' + (this.state.term * 12) + '&extendedRateStartMonth=' + (this.state.competitorCommitmentPeriod * 12) + '&initialRate=' + this.state.competitorInitialRate + '&extendedRate=' + this.state.competitorExtendedRate, {
            headers: {
                'x-functions-key': window.mortgageCalculatorConfig.competitorCalculation.xFunctionsKey
            } 
        })
        .then(function (response) {
            self.setState({hasResult: true, calcDataCompetitor: response.data.competitorData, competitorHasCalculation: true, isLoading: false});
        })
        .catch(function (error) {
            self.setState({isLoading: false, hasError: true, errorMsg: error});
        });
    }

    getCalculation(term){
        var self = this;
        this.setState({isLoading: true});
        var apiEndpoint = 'https://func-py-mortgage-calculator.azurewebsites.net/api/mortgage-calculation?purchasePrice=' + this.state.purchasePrice + '&applicantContribution=' + this.state.deposit + '&termRequested=' + (this.state.term * 12);
        if(this.state.isInternal){
            apiEndpoint += '&flexInterestRate=' + this.state.interestFlex + '&advantageInterestRate=' + this.state.interestRateFirst5Years + '&advantageExtendedRate=' + this.state.interestRateAfter5Years;
        }
        axios.get(apiEndpoint, {
            headers: {
                'x-functions-key': window.mortgageCalculatorConfig.mortgageCalculation.xFunctionsKey
            } 
        })
        .then(function (response) {
            self.setState({hasResult: true, hasError: false, calcData: response.data});
            self.setState({isLoading: false});
            if(self.state.competitorDisplay){
                self.getCompetitorCalculation();
            }
            
        })
        .catch(function (error) {
            self.setState({errorMsg: error.response.data[0], isLoading: false, hasError: true});
        });
    }

    applyMortgage(){
        var self = this;
        //Validation
        if(this.state.applyMortgageName === '' || this.state.applyMortgageEmail === '' || this.state.applyMortgagePhone === ''){
            this.setState({applyMortgageValidateError: true, applyMortgageMsg: 'Please fill required fields'}); 
            return;
        }

        if(/\S+@\S+\.\S+/.test(this.state.applyMortgageEmail) === false){
            this.setState({applyMortgageValidateError: true, applyMortgageMsg: 'Please insert a valid email address'}); 
            console.log('email');
            return;
        }
        this.setState({applyMortgageValidateError: false, applyMortgageMsg: ''});

        var data = {
            "form[name]": this.state.applyMortgageName,
            "form[phone]": this.state.applyMortgagePhone,
            "form[email]": this.state.applyMortgageEmail,
            "form[address]": this.state.applyMortgageAddress,
            "form[city]": this.state.applyMortgageCity,
            "form[loanType]": this.state.applyMortgageLoanType,
            "form[loanAmount]": this.state.purchasePrice - this.state.deposit,
            "form[deposit]": this.state.deposit,
            "form[term]": this.state.term,
            "form[interestRate]": this.state.interestRateFirst5Years,
            "form[extendedInterestRate]": this.state.interestRateAfter5Years,
            "form[flexInterestRate]": this.state.interestFlex,
            "form[alreadyCustomer]": this.state.applyMortgageAlreadyCustomer,
            'form[formId]': '24', //Hardcoded for now
            "form[secret]": 'iZg4Tr3325!C',
            'form[send]': 'Send' 
        }
        const FD = new FormData();
        // Push our data into our FormData object
        for (const [name, value] of Object.entries(data)) {
            FD.append(name, value);
        }
        //Joomla csrf token
        if(document.querySelector('.joomla-script-options')){
            FD.append(JSON.parse(document.querySelector('.joomla-script-options').innerText)['csrf.token'], '1'); 
        }
        
        axios({
            method: "post",
            url: document.location.href, //Post to current page - requeres form on page
            data: FD,
            headers: { "Content-Type": "multipart/form-data" },
          }).then(function (response) {
            self.setState({applyMortgageMsg: self.state.applyMortgageSuccessMsg, applyMortgageSendSuccess: true});
        })
        .catch(function (error) {
            self.setState({applyMortgageMsg: error.message, applyMortgageSendError: true});
       });
    }

    addCompetitorData(){
        this.getCalculation();
        this.setState({competitorDisplay: true});
        this.closeModalCompetitor();
        document.getElementById('MortgageCalculatorTable').scrollIntoView();
    }

    toggleCompetitorData(){
        this.setState({competitorDisplay: !this.state.competitorDisplay});
    }

    resetCompetitorData(){
        this.setState({
            competitorDisplay: false,
            competitorHasCalculation: false,
            competitorCommitmentPeriod: window.mortgageCalculatorConfig.competitorCommitmentPeriodDefault,
            competitorInitialRate: window.mortgageCalculatorConfig.competitorInitialRateDefault,
            competitorExtendedRate: window.mortgageCalculatorConfig.competitorExtendedRateDefault
        });
        
        this.getCalculation();
        this.closeModalCompetitor();
    }

    handleDepositChange(e){
        this.setState({ deposit: e })
        this.chartReference.data.datasets[0].data = [this.state.deposit, (this.state.purchasePrice - this.state.deposit)];
        this.chartReference.update();
    }

    handlePurchasePriceChange(e){
        this.setState({ purchasePrice: e })
        this.chartReference.data.datasets[0].data = [this.state.deposit, (this.state.purchasePrice - this.state.deposit)];
        this.chartReference.update();
    }

    componentDidMount() {
        //console.log(this.chartReference); // returns a Chart.js instance reference
    }

    createSelectItemsTerm() {
        let items = [];         
        for (let i = window.mortgageCalculatorConfig.termMin; i <= window.mortgageCalculatorConfig.termMax; i++) {             
             items.push(<option key={i} value={i}>{i}</option>);   
             //here I will be creating my options dynamically based on
             //what props are currently passed to the parent component
        }
        return items;
    } 

    createSelectItemsCompetitorPeriod() {
        let items = [];         
        for (let i = window.mortgageCalculatorConfig.competitorCommitmentPeriodMin; i <= window.mortgageCalculatorConfig.competitorCommitmentPeriodMax; i++) {             
             items.push(<option key={i} value={i}>{i}</option>);   
        }
        return items;
    } 


    render() {
        return ( 
            <div className='mortgage-calculator'>

                <div className='mortgage-calculator__container'>
                    <div className='mortgage-calculator__input'>
                        <div className="mortage-calculator__input-form">
                            <form onSubmit={ this.handleSubmit }>
                                <div className="label-and-field-wrapper field-wrapper--width-normal">
                                    <label>Purchase price </label>
                                    <div className="field-with-icon-wrapper">
                                        <div className="field-with-icon-wrapper__icon field-with-icon-wrapper__icon-house">
                                            <img src="/images/mortgage-calculator/icon-house.svg" alt="House icon" />
                                        </div>
                                        <CurrencyInput id="input-purchase-price" className='uk-xyz' name="input-purchase-price" decimalsLimit={ 2 } prefix="£ " value={this.state.purchasePrice} onValueChange={this.handlePurchasePriceChange}></CurrencyInput>
                                    </div>
                                </div>
                                <div className="label-and-field-wrapper">
                                    <label>Your deposit </label>
                                    <div className="field-with-icon-wrapper">
                                        <div className="field-with-icon-wrapper__icon field-with-icon-wrapper__icon-coins">
                                            <img src="/images/mortgage-calculator/icon-coins.svg" alt="Coins icon" />
                                        </div>
                                        <CurrencyInput id="input-your-deposit"  className='uk-xyz' name="input-your-deposit" placeholder="Enter deposit" defaultValue={42101} decimalsLimit={ 2 } prefix="£ " value={this.state.deposit} onValueChange={this.handleDepositChange} />
                                    </div>
                                </div>
                                <div className="label-and-field-wrapper">
                                    <label> Term </label>
                                    <div>
                                        <select value={this.state.term} onChange={this.handleTermChange} >
                                            {this.createSelectItemsTerm()}
                                        </select>
                                    </div>
                                </div>
                                {this.state.isInternal === true && (
                                    
                                        <div className="label-and-field-wrapper mortgage-calculator__interest-rate-input">
                                            <div>
                                                <label>Flex <span className="wrap-desktop">Interest rate</span></label>
                                                <div className='field-wrapper'>
                                                    <input id="interestFlex" className='uk-xyz' type="number" value={this.state.interestFlex} onChange={e => {
                                                        this.setState({ interestFlex: e.target.value });
                                                        this.value = this.state.interestFlex;
                                                    }}></input> %
                                                </div>
                                            </div>
                                            <div>
                                                <label>Advantage <span className="wrap-desktop">Interest first 5 years</span></label>
                                                <div className='field-wrapper'>
                                                    <input id="interestFirst" className='uk-xyz' type="number" value={this.state.interestRateFirst5Years}  
                                                    onChange={e => {
                                                        this.setState({ interestRateFirst5Years: e.target.value });
                                                        this.value = this.state.interestRateFirst5Years;
                                                    }}></input> %
                                                </div>
                                            </div>
                                            <div>
                                                <label>Advantage <span className="wrap-desktop">Interest after 5 years</span></label>
                                                <div className='field-wrapper'>
                                                    <input id="interestLast" className='uk-xyz' type="number" value={this.state.interestRateAfter5Years}  
                                                    onChange={e => {
                                                        this.setState({ interestRateAfter5Years: e.target.value });
                                                        this.value = this.state.interestRateAfter5Years;
                                                    }}
                                                    ></input> %
                                                </div>
                                            </div>
                                        </div>
                                )}
                                <button type="submit" className='button-primary' value="calculate" disabled={this.state.isLoading}>Calculate</button>
                
                                {this.state.isLoading === true && (<LoadingSpinner />)}

                                {this.state.hasError > 0 && (
                                <div className='mortgage-calculator__error-message'>Oops! Something went wrong<br/><span class="mortgage-calculator__error-message-text">{this.state.errorMsg}</span></div>
                                )}
                    
                            </form>
                        </div>
                        <div className='mortgage-calculator__input-graph'  style={{"backgroundImage":"url(/images/mortgage-calculator/icon-house-doghnut.svg)"}}>
                            <Doughnut ref = {(reference) => this.chartReference = reference} data={this.chartdata } options={this.chartOptions} />
                        </div>
                    </div>
                    
                    {this.state.hasResult === true && (
                    <MortgageCalculationTable calcData={this.state.calcData} competitorDisplay={this.state.competitorDisplay} competitorHasCalculation={this.state.competitorHasCalculation} competitorCommitmentPeriod={this.state.competitorCommitmentPeriod} competitorCalc={this.state.calcDataCompetitor} interestComment={this.state.interestComment} />
                    )}
                    {this.state.hasResult === true && (
                    <ChartPayment calcData={this.state.calcData} calcDataCompetitor={this.state.calcDataCompetitor} competitorDisplay={this.state.competitorDisplay} competitorHasCalculation={this.state.competitorHasCalculation} />
                    )}
                    {this.state.hasResult === true && (
                    <ChartInterestRate term={this.state.term} competitorCommitmentPeriod={this.state.competitorCommitmentPeriod} calcData={this.state.calcData} calcDataCompetitor={this.state.calcDataCompetitor} competitorDisplay={this.state.competitorDisplay} competitorHasCalculation={this.state.competitorHasCalculation} />
                    )}
                </div>
                {this.state.hasResult === true && (
                <div className='mortgage-calculator__toolbar' >
                    <div className='mortgage-calculator__toolbar__inner'>
                        {this.state.isInternal === true && (
                        <div className='mortgage-calculator__toolbar-left'>
                            {this.state.competitorHasCalculation === false && (
                            <button onClick={this.openModalCompetitor} className='button-link button-text-icon'>
                                <img src="/images/mortgage-calculator/icon-plus.svg" alt="Plus icon" />
                                <span>ADD COMPETITOR DATA</span>
                            </button>
                            )}
                            {this.state.competitorHasCalculation === true && (
                                <div className='mortgage-calculator__toolbar-edit'>
                                    <Toggle ref={this.toggleReference} onChange={this.toggleCompetitorData} checked={this.state.competitorDisplay}></Toggle><span>Show competitor data</span>
                                    <button onClick={this.openModalCompetitor} className='button-link button-text-icon'>
                                        <img src="/images/mortgage-calculator/icon-edit.svg" alt="Edit icon" />
                                        <span>Edit competitor data</span>
                                    </button>
                                </div>
                            )}
                            
                        </div>
                        )}
                        <div className='mortgage-calculator__toolbar-right'>
                            <button type="submit" value='Apply For mortgage' className='button-primary button-primary--dark' onClick={this.openModal}>APPLY FOR MORTGAGE</button>
                        </div>
                    </div>
                </div>
                )}

                <Modal 
                isOpen={this.state.modalCompetitorIsOpen}
                onRequestClose={this.closeModalCompetitor}
                style={customStyles}
                contentLabel="Add competitor data"
                >
                <div className="mortgage-calculator">
                    <h2>Competitor data</h2>
                    <div className="label-and-field-wrapper mortgage-calculator__interest-rate-input">
                        <div>
                            <div className="label-and-field-wrapper">
                                <label>Choose commitment period</label>
                                <div className='field-wrapper'>
                                    <select value={this.state.competitorCommitmentPeriod} onChange={this.handleCommitmentPeriodChange}>
                                        {this.createSelectItemsCompetitorPeriod()}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div>
                            <label>Interest first 5 years</label>
                            <div className='field-wrapper'>
                                <input id="interestFirst" className='uk-xyz' type="number" value={this.state.competitorInitialRate}  
                                onChange={e => {
                                    this.setState({ competitorInitialRate: e.target.value });
                                    this.value = this.state.competitorInitialRate;
                                }}></input> %
                            </div>
                        </div>
                        <div>
                            <label>Interest after 5 years </label>
                            <div className='field-wrapper'>
                                <input id="interestLast" className='uk-xyz' type="number" 
                                value={this.state.competitorExtendedRate}  
                                onChange={e => {
                                    this.setState({ competitorExtendedRate: e.target.value });
                                    this.value = this.state.competitorExtendedRate;
                                }}
                                ></input> %
                            </div>
                        </div>
                    </div>
                    <div>
                        <button id='addCompetitorData' className='button-primary' onClick={this.addCompetitorData}>Add data</button>
                        <button id='resetCompetitorData' className='button-primary button-primary--beige' onClick={this.resetCompetitorData}>Remove data and close</button>
                    </div>
                </div>
                </Modal>

                <Modal
                isOpen={this.state.modalApplyIsOpen}
                onAfterOpen={this.afterOpenModal}
                onRequestClose={this.closeModal}
                style={customStyles}
                contentLabel="Apply Modal"
                >
                <div className="mortgage-calculator">
                    <h2>Apply for mortgage</h2>
                    <div className="label-and-field-wrapper">
                        <label>Name *</label>
                        <div className='field-wrapper'>
                        <input type="text" value={this.state.applyMortgageName} onChange={e => {
                                            this.setState({ applyMortgageName: e.target.value });
                                            this.value = this.state.applyMortgageName;
                                        }}></input>
                        </div>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>Phone *</label>
                        <div className='field-wrapper'>
                            <input type="text" value={this.state.applyMortgagePhone} onChange={e => {
                                                this.setState({ applyMortgagePhone: e.target.value });
                                                this.value = this.state.applyMortgagePhone;
                                            }}></input>
                        </div>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>Email *</label>
                        <div className='field-wrapper'>
                            <input type="text" value={this.state.applyMortgageEmail} onChange={e => {
                                                this.setState({ applyMortgageEmail: e.target.value });
                                                this.value = this.state.applyMortgageEmail;
                                            }}></input>
                        </div>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>Address</label>
                        <div className='field-wrapper'>
                            <input type="text" value={this.state.applyMortgageAddress} onChange={e => {
                                                this.setState({ applyMortgageAddress: e.target.value });
                                                this.value = this.state.applyMortgageAddress;
                                            }}></input>
                        </div>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>City</label>
                        <div className='field-wrapper'>
                            <input type="text" value={this.state.applyMortgageCity} onChange={e => {
                                                this.setState({ applyMortgageCity: e.target.value });
                                                this.value = this.state.applyMortgageCity;
                                            }}></input>
                        </div>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>Choose loan type to apply for</label>
                        <select  className='field-wrapper--width-normal' value={this.state.applyMortgageLoanType} onChange={e => {this.setState({ applyMortgageLoanType: e.target.value }); this.value = this.state.applyMortgageLoanType}}>
                            <option value={"Flex Amortised"}>Flex Amortised</option>
                            <option value={"Flex Serial"}>Flex Serial</option>
                            <option value={"Advantage Amortised"}>Advantage Amortised</option>
                            <option value={"Advantage Serial"}>Advantage Serial</option>
                        </select>
                    </div>
                    <div className="label-and-field-wrapper">
                        <label>Already a customer?</label>
                        <div className='mortgage-calculator-checkbox-wrapper'>
                            <input id='mortgageCalculatorApplyIsCustomerYes' type="radio" value="Yes" name="allready-customer" onChange={this.handleApplyMortgageAlreadyCustomer} checked={this.state.applyMortgageAlreadyCustomer === 'Yes'}></input><label htmlFor='mortgageCalculatorApplyIsCustomerYes'>Yes</label>
                            <input id='mortgageCalculatorApplyIsCustomerNo' type="radio" value="No" name="allready-customer" onChange={this.handleApplyMortgageAlreadyCustomer} checked={this.state.applyMortgageAlreadyCustomer === 'No'}></input><label htmlFor='mortgageCalculatorApplyIsCustomerNo'>No</label>
                        </div>
                    </div>
                    <div>
                        {this.state.applyMortgageSendSuccess === true && (
                        <div className='mortgage-calculator__success-message'>
                            <span dangerouslySetInnerHTML={{__html: this.state.applyMortgageMsg}} />
                        </div>
                        )}
                        {this.state.applyMortgageValidateError === true && (
                        <div className='mortgage-calculator__error-message'>
                            <span dangerouslySetInnerHTML={{__html: this.state.applyMortgageMsg}} />
                        </div>
                        )}
                        {this.state.applyMortgageSendError === true && (
                        <div className='mortgage-calculator__error-message'>
                            Oops! Something went wrong<br/><span>{this.state.applyMortgageMsg}</span>  
                        </div>
                        )}
                        {this.state.applyMortgageSendSuccess === false && this.state.applyMortgageSendError === false && (
                        <button id='sendApplyMortgage' className='button-primary button-primary--dark' onClick={this.applyMortgage}>APPLY FOR MORTGAGE</button>
                        )}
                        <button className='button-primary button-primary--beige' onClick={this.closeModal}>CLOSE</button>
                        
                    </div>
                    
                </div>
                </Modal>

            </div>

            
            
            

        );
    }
}

export default Calculator;